export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 101 101">
    <path
      fillRule="evenodd"
      d="M51.3.2l2.4.6c2.5.7 4.6 2 6.3 3.9 3.7 4.2 7.4 8.3 11 12.5.4.5.9.7 1.5.6 10.4-1.7 19.5 1 27.3 8.1.2.2.5.4.7.5v.2c-.1.1-.2.1-.3.2-14 12.4-27.9 24.8-41.9 37.3-1.7 1.5-3.3 3-5 4.5-.3-.4-.5-.6-.7-.9-5.9-8.4-7.5-17.5-4.9-27.4.2-.7.1-1.2-.4-1.8-3.9-4.4-7.7-8.8-11.5-13.2-4-4.6-4.7-11.5-1.9-16.7 2.1-4 5.7-6.1 9.9-7.4C45 .8 46.3.6 47.5.4 48.7.2 50 .2 51.3.2zm19.8 101.6c-1.5-2.6-3.5-4.5-5.8-6.1-3.8-2.6-8.1-4.1-12.7-4.8-1.6-.3-3.3-.5-5-.6-.9 0-1.5-.4-2.1-1-6.5-6.5-13.1-13-19.6-19.6l-.7-.7c-1.5 3-3.6 5.4-6.4 7.1 5.1 5.1 10.2 10.2 15.5 15.4-6.4 1.9-11.8 4.6-15.4 10.3h52.2z"
    />
    <path
      fillRule="evenodd"
      d="M18.3 48.9c3 1.7 5.1 4 6.7 7.1 6.1-4.9 12.2-9.7 18.3-14.6-2-2.5-4-5-6.1-7.6-6.3 5-12.5 10-18.9 15.1z"
    />
    <circle fillRule="evenodd" cx="10.6" cy="62.7" r="10.1" />
  </svg>
);
